import Icon from '../components/Icon.vue'

Icon.register({"bandcamp":{"width":1792,"height":1792,"paths":[{"d":"M1070 1178l306-564h-654l-306 564h654zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bandcamp.js
// module id = 867
// module chunks = 0